import {
  BORDER_RADIUS,
  BREAKPOINT,
  COLOR,
  REBRAND_COLOR,
  MARGIN,
  PADDING
} from '@latitude/core/utils/constants';
import Accordion from '../LabRatesAndFeesColumnRebrand/Accordion/Accordion';
import { Link } from '@latitude/link';
import styled from 'styled-components';
import Section from '@latitude/section-rebrand';

export const MainWrapper = styled(Section)`
  background: ${REBRAND_COLOR.WHITE};
  padding-top: ${PADDING.P32};
  padding-bottom: ${PADDING.P32};
  a {
    text-underline-offset: 3px; 
  }
`;

export const StyledMainGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  gap: 1rem;
  @media (min-width: ${BREAKPOINT.MD}) {
    grid-template-columns: repeat(
      ${({ length }) => (length && length > 4 ? 4 : length)},
      1fr
    );
    grid-template-rows: 1fr;
  }
`;

export const StyledGridItem = styled.div``;

export const StyledIconWrapper = styled.div`
  width: 56px;
  height: 56px;
  margin-bottom: ${MARGIN.M8};
  svg {
    width: 100%;
    height: 100%;
  }
`;

export const StyledHeading = styled.div`
  color: ${COLOR.BLACK};
  margin: 0 0 ${MARGIN.M8} 0;
`;
export const StyledSubHeading = styled.div``;

export const LearnMoreLink = styled(Link)`
    text-decoration: underline;
    line-height: inherit;
    font-weight: inherit;
    font-size: inherit;
    color: ${REBRAND_COLOR.BLACK_80} !important;
  }
`;

export const MoreFeatures = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  gap: 1rem;
  @media (min-width: ${BREAKPOINT.MD}) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr;
  }
`;

export const MoreFeaturesLeft = styled.div``;

export const MoreFeaturesRight = styled.div``;

export const MoreFeatureWrapper = styled.div`
  display: flex;
  gap: 0.2rem;
`;

export const MoreFeatureDotWrapper = styled.div`
  display: flex;
  align-items: start;
  justify-content: center;
  padding: ${PADDING.P4};
`;

export const MoreFeatureDot = styled.div`
  background: ${COLOR.BLUE_LIGHT};
  height: 10px;
  width: 10px;
  border-radius: ${BORDER_RADIUS.CIRCLE};
  margin-top: 3px;
`;

export const MoreFeatureTextContent = styled.div``;

export const StyledAccordion = styled(Accordion)`
  margin-top: ${MARGIN.M24};

  .accordion__item-body {
    padding: 0;
    background-color: transparent !important;
  }
  .open {
    margin: ${PADDING.P16};
  }
  .link-block {
    color: ${REBRAND_COLOR.INDIGO} !important;
    background-color: ${REBRAND_COLOR.WHITE};
    border: 1px solid ${REBRAND_COLOR.BLACK_40};
    border-radius: 8px;
  }
  .link-block:focus {
    outline: none;
  }
  .is-open {
    position: relative;
    border-bottom: 1px solid ${REBRAND_COLOR.BLACK_40};
    border-top: 1px solid ${REBRAND_COLOR.WHITE};
    border-radius: 8px;
  }
    /* Left border */
  .is-open::before {
    content: "";
    position: absolute;
    top: 50px;
    bottom: 4.2px;
    left: 0;
    width: 1px;
    background-color:  ${REBRAND_COLOR.BLACK_40};
  }

  /* Right border */
  .is-open::after {
    content: "";
    position: absolute;
    top: 50px;
    right: 0;
    bottom: 4.2px;
    width: 1px;
    background-color:  ${REBRAND_COLOR.BLACK_40};
  }
`;

export const GridTitle = styled.div`
  margin-bottom: ${MARGIN.M32};
`;

export const StyledHeader = styled.div`
  margin-bottom: ${MARGIN.M8};
`;
